import { createSlice } from "@reduxjs/toolkit";

const tabIdSlice = createSlice({
  name: "tabId",
  initialState: null,
  reducers: {
    setTabId: (state, action) => {
      return action.payload;
    },
  },
});

export const { setTabId } = tabIdSlice.actions;
export const mainTabId = tabIdSlice.reducer;
